import yup from "src/validators/yup.Module";

export interface TributacaoMensagemDto {
  id: number;
  mensagem: string;
  padrao?: boolean;
}

export interface TributacaoMensagemFiltrarDto {
  id?: number;
  mensagem?: string;
  padrao?: boolean;
}

export const TributacaoMensagemFiltrarSchema = yup.object().shape({
  mensagem: yup.string().notRequired(),
  padrao: yup.boolean().notRequired(),
});
